import { makeIntl } from '@mit/intl';

import type { BlockType } from '../schema';

export const { FormattedMessage, useIntl } = makeIntl<BlockType>();
